import React from "react";
import styles from "./admin.module.scss";

/** Stroke icon paths used across the admin panel (24×24 grid). */
export const iconPaths = {
  mosque: "M3 21h18M5 21V11l7-5 7 5v10M9 21v-5h6v5M12 2.5v3",
  people:
    "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8zM22 21v-2a4 4 0 0 0-3-3.9M16 3.1a4 4 0 0 1 0 7.8",
  table:
    "M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zM3 10h18M9 4v16",
  clock: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 7v5l3 2",
  bell: "M6 8a6 6 0 1 1 12 0c0 7 3 9 3 9H3s3-2 3-9M10.3 21a1.9 1.9 0 0 0 3.4 0",
  tv: "M3 5h18v12H3zM8 21h8M12 17v4",
  cal: "M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zM3 10h18M8 3v4M16 3v4",
  doc: "M6 3h9l4 4v14H6zM14 3v5h5M9 13h7M9 17h5",
  info: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM12 11v6M12 7.5v.01",
  heart:
    "M12 21s-8-4.5-8-11a4.5 4.5 0 0 1 8-2.8A4.5 4.5 0 0 1 20 10c0 6.5-8 11-8 11z",
  pin: "M12 21s-7-6.2-7-12a7 7 0 0 1 14 0c0 5.8-7 12-7 12zM12 6.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5z",
  wand: "M15 4V2M15 10V8M11 6h2M17 6h2M3 21 14 10M17.5 14.5l1 1M20 11l1 1",
  moon: "M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z",
  users:
    "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 3a4 4 0 1 1 0 8 4 4 0 0 1 0-8zM19 8v6M22 11h-6",
  plus: "M12 5v14M5 12h14",
  inbox: "M3 13h5l1 3h6l1-3h5M5 5h14l2 8v6H3v-6z",
  book: "M2 4h7a3 3 0 0 1 3 3v14a2 2 0 0 0-2-2H2zM22 4h-7a3 3 0 0 0-3 3v14a2 2 0 0 1 2-2h8z",
  star: "M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.4 6.8 19.1l1-5.8L3.5 9.2l5.9-.9z",
  quote: "M7 7h4v4c0 3-1.5 5-4 6M15 7h4v4c0 3-1.5 5-4 6",
  spark:
    "M12 3v4M12 17v4M3 12h4M17 12h4M6 6l2.5 2.5M15.5 15.5 18 18M6 18l2.5-2.5M15.5 8.5 18 6",
  db: "M4 6c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3zM4 6v12c0 1.7 3.6 3 8 3s8-1.3 8-3V6M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3",
  link: "M10 14a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1M14 10a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1",
  thumbs:
    "M7 10v11M7 10l4-7a2 2 0 0 1 3 2l-1 5h6a2 2 0 0 1 2 2l-2 7a2 2 0 0 1-2 2H7",
  hijri:
    "M5 5h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zM3 10h18M15 14.5a2.5 2.5 0 1 1-2.5-2.5 2 2 0 0 0 2.5 2.5z",
  code: "M8 8l-5 4 5 4M16 8l5 4-5 4M14 4l-4 16",
  chart: "M4 20V10M10 20V4M16 20v-7M22 20H2",
  key: "M15 3a6 6 0 1 0 0 12 6 6 0 0 0 0-12zM10.5 13.5 3 21M6 18l2 2M8 16l2 2",
  logout: "M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3M10 17l5-5-5-5M15 12H4",
  swap: "m7 15 5 5 5-5M7 9l5-5 5 5",
  upload: "M12 21V9M7 14l5-5 5 5M4 5h16",
  download: "M12 3v12M7 10l5 5 5-5M4 19h16",
  check: "M5 12.5l4.5 4.5L19 7.5",
  x: "M6 6l12 12M18 6 6 18",
  alert: "M12 3 2 21h20L12 3zM12 10v5M12 18v.01",
  trash: "M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3",
  edit: "M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4",
  search: "M11 4a7 7 0 1 0 0 14 7 7 0 0 0 0-14zM20 20l-4-4",
  copy: "M9 9h11v11H9zM5 15H4V4h11v1",
  chevronLeft: "M15 6l-6 6 6 6",
  chevronRight: "M9 6l6 6-6 6",
  more: "M12 5v.01M12 12v.01M12 19v.01",
  coffin: "M9 3h6l3 5-3 13H9L6 8z",
};

export type IconName = keyof typeof iconPaths;

interface IconProps {
  name: IconName;
  size?: number;
  strokeWidth?: number;
  className?: string;
  title?: string;
}

const Icon: React.FC<IconProps> = ({
  name,
  size = 18,
  strokeWidth = 1.8,
  className,
  title,
}) => (
  <svg
    className={`${styles.icon} ${className ?? ""}`}
    viewBox="0 0 24 24"
    width={size}
    height={size}
    strokeWidth={strokeWidth}
    aria-hidden={title ? undefined : true}
    role={title ? "img" : undefined}
    aria-label={title}
  >
    <path d={iconPaths[name]} />
  </svg>
);

export default Icon;
